module.exports = __webpack_public_path__ + "static/media/solutionpage-macbook.e6dece35.png";